import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import functionsService from '../../../services/functionsService';
import get from 'lodash/get';
export default {
  name: 'IsFMFavaccessmgmt',
  props: {
    item: {
      type: Object,
      required: true
    },
    tileSizeSetting: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: function data() {
    return {
      loader: null,
      loading: false,
      value: 0,
      interval: {},
      isfmaccess: null,
      imgsrc: './img/transponder.png',
      avatarLoader: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    dsize: function dsize() {
      if (this.tileSizeSetting === 1) {
        return '-big';
      }

      return '';
    }
  }),
  watch: {
    loader: function loader() {
      var _this = this;

      var l = this.loader;
      this[l] = !this[l];
      setTimeout(function () {
        return _this[l] = false;
      }, 11500);
      this.loader = null;
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted: function mounted() {
    this.digitalTwinGetData();
  },
  methods: {
    keyTwinTitle: function keyTwinTitle(item) {
      return "".concat(get(item, 'dtwinData.title'), " (").concat(get(item, 'parentData.title'), ")");
    },
    processDoor: function processDoor(isfmaccessid) {
      var _this2 = this;

      this.loader = 'loading';
      this.avatarLoader = true;
      this.value = 0;
      ApiService.isFmAccessActivateLock({
        id: isfmaccessid
      }).then(function () {
        _this2.$snack(_this2.$i18n_t('IS.FM.AccessMgmt.doorActivated'), 'success');
      }).catch(function (error) {
        var userRights = functionsService.userAccessRightHandling(error.response.data.data, _this2);

        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack("".concat(userRights, " - ").concat(_this2.$i18n_t('IS.FM.AccessMgmt.doorFailed')), 'error');
        }
      }).finally(function () {
        _this2.$store.state.app.loading = false;
      });
      this.interval = setInterval(function () {
        if (_this2.value >= 100) {
          _this2.avatarLoader = false;

          _this2.endIntervall();
        }

        _this2.value += 17;
      }, 1000);
    },
    endIntervall: function endIntervall() {
      clearInterval(this.interval);
    },
    digitalTwinGetData: function digitalTwinGetData() {
      var _this3 = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      ApiService.isFmAccessGet(this, this.item.objectId).then(function (data) {
        _this3.isfmaccess = data;

        if (!data || !data.id) {
          _this3.$emit('invalid');
        }
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.errorLoadingData'), 'error');
        }
      }).finally(function () {
        _this3.$store.state.app.loading = false;
      });
    }
  }
};